// eslint-disable-next-line no-restricted-exports
export { default } from './FormTextarea';
export * from './FormTextarea';
